import styled, { css } from 'styled-components';

import { Box } from 'components/Box';
import { colors } from 'theme/theme';

import { DropBox } from './DropBox';
import { OverlayDropContent } from './OverlayDropContent';

export const DropContainer = styled(Box)<{
  $dragActive?: boolean;
  $hasImage?: boolean;
  $overlayButton?: boolean;
}>`
  cursor: pointer;
  ${(props) =>
    props.$dragActive &&
    css`
      ${DropBox} {
        & > * {
          border-color: ${props.$overlayButton && props.$hasImage
            ? 'white'
            : colors.hoverBlue};
          color: ${props.$overlayButton && props.$hasImage
            ? 'white'
            : colors.hoverBlue};
        }
        &::before {
          opacity: 1;
        }
      }
      ${OverlayDropContent} {
        opacity: 1;
      }
    `}
`;
